import { motion } from "framer-motion";
import {
  SwimmingPool,
  Flag,
  Tree,
  ShieldCheck,
  Barbell,
  Bicycle,
  GraduationCap,
  Storefront,
} from "@phosphor-icons/react";
import { IMAGES } from "@/constants/site";

const AMENITIES = [
  { icon: Flag, title: "9-Hole Golf Course", desc: "Championship greens at your doorstep" },
  { icon: SwimmingPool, title: "Clubhouse & Pools", desc: "Belvedere Golf & Country Club access" },
  { icon: Tree, title: "7-Acre Lake", desc: "Shantigram Lake & central greens" },
  { icon: Barbell, title: "Sports Academy", desc: "Adani Sports Academy coaching" },
  { icon: Bicycle, title: "Jogging & Cycling", desc: "Dedicated tracks across the township" },
  { icon: GraduationCap, title: "Schools Inside", desc: "Education within the gates" },
  { icon: Storefront, title: "Retail & High Street", desc: "Daily needs, minutes away" },
  { icon: ShieldCheck, title: "24×7 Security", desc: "Multi-tier gated protection" },
];

export default function Amenities() {
  return (
    <section id="amenities" data-testid="amenities-section" className="bg-cream py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7 }}
            className="md:col-span-4"
          >
            <p className="text-xs font-semibold uppercase tracking-[0.25em] text-forest/70">Amenities</p>
            <h2 className="mt-4 font-serif text-2xl tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">
              A life that never asks you to leave
            </h2>
            <p className="mt-6 text-base leading-relaxed text-slate-600">
              Township-scale amenities mean weekends at the club, mornings by the lake and evenings on the greens —
              all without stepping out of your address.
            </p>
            <div className="mt-8 overflow-hidden rounded-lg">
              <img
                src={IMAGES.pool}
                alt="Clubhouse pool at Adani Shantigram"
                className="h-64 w-full object-cover transition-transform duration-700 hover:scale-105"
              />
            </div>
          </motion.div>
          <div className="grid grid-cols-1 gap-x-10 gap-y-10 sm:grid-cols-2 md:col-span-8">
            {AMENITIES.map((a, i) => (
              <motion.div
                key={a.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.5, delay: i * 0.06 }}
                data-testid={`amenity-${a.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="border-t border-slate-200 pt-6"
              >
                <a.icon size={28} weight="duotone" className="text-forest" />
                <h3 className="mt-4 font-serif text-lg text-slate-900">{a.title}</h3>
                <p className="mt-1 text-sm text-slate-500">{a.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
